<template>
  <v-flex>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Reporte de Marketing por Agencia</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-chip label class="mr-1" link :color="colorAccent1" @click="_exportarExcel">
          <span style="color: white;">Exportar a Excel</span>
        </v-chip>
      </v-toolbar>

      <v-card-text>
        <v-row class="mt-0" justify="start" dense>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="busquedaDesde"
              class="mx-4"
              :dark="dark"
              clearable
              dense
              outlined
              autocomplete="off"
              label="Búsqueda por fecha desde"
              placeholder="AAAA-MM-DD"
              hint="Formato: AAAA-MM-DD"
              persistent-hint
              maxlength="10"
              :error-messages="errorDesde"
              @input="validateFechaDesde"
              @keyup.enter="_getReporteMarketingAgencia"
            />
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="busquedaHasta"
              class="mx-4"
              :dark="dark"
              clearable
              dense
              outlined
              autocomplete="off"
              label="Búsqueda por fecha hasta"
              placeholder="AAAA-MM-DD"
              hint="Formato: AAAA-MM-DD"
              persistent-hint
              maxlength="10"
              :error-messages="errorHasta"
              @input="validateFechaHasta"
              @keyup.enter="_getReporteMarketingAgencia"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-col cols="12" class="mt-12"><v-progress-linear class="mt-12 mb-12" :color="colorAccent1" indeterminate rounded height="6" /></v-col>
      <v-spacer />
    </v-row>

    <v-card v-if="!loading" class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Estadísticas por Agencia</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row v-if="porOrigen.length" class="mt-2" justify="center" dense>
          <v-col cols="12">
            <v-card class="pa-4">
              <h2 class="mb-4 text-center">Distribución de Reservas por Agencia</h2>
              <v-row>
                <v-col cols="12" md="6" class="d-flex justify-center align-center"><canvas ref="pieChart" width="400" height="400" /></v-col>
                <v-col cols="12" md="6" class="d-flex align-center">
                  <div class="leyenda-agencias">
                    <div v-for="(item, index) in datosGrafica" :key="item.origen_id" class="leyenda-agencias__item">
                      <span class="leyenda-agencias__color" :style="{ backgroundColor: colores[index % colores.length] }"></span>
                      <span><strong>{{ item.origen_nombre }}</strong><br><small>{{ item.total_reservas }} reservas ({{ porcentaje(item.total_reservas) }}%)</small></span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="porOrigen" :items-per-page="-1" hide-default-footer locale="es" dense class="mt-2 elevation-1 alternating-rows bordered-table">
          <template v-slot:body.append>
            <tr class="font-weight-bold" style="background-color: #e3f2fd;">
              <td class="text-left">TOTALES</td>
              <td class="text-center">{{ totales.DesdeOficinaPresupuestadas }}</td>
              <td class="text-center">{{ totales.DesdeOficinaReservadas }}</td>
              <td class="text-center">{{ totales.total }}</td>
            </tr>
          </template>
          <template v-slot:no-data>No hay datos disponibles</template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card v-if="!loading" class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title :dark="!dark">Distribución de Caminos por Agencia</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row v-if="porOrigenConCaminos.length" dense>
          <v-col v-for="agencia in porOrigenConCaminos" :key="agencia.origen_id" cols="12" lg="6">
            <v-card class="pa-4 fill-height">
              <h2 class="mb-1 text-center">{{ agencia.origen_nombre }}</h2>
              <p class="text-center mb-4">{{ agencia.total_reservas || 0 }} reservas</p>
              <v-row>
                <v-col cols="12" sm="6" class="d-flex justify-center align-center">
                  <canvas :ref="'pieChartCamino' + agencia.origen_id" width="300" height="300" />
                </v-col>
                <v-col cols="12" sm="6" class="d-flex align-center">
                  <div class="leyenda-agencias">
                    <div v-for="(camino, index) in caminosConReserva(agencia)" :key="camino.camino_id" class="leyenda-agencias__item">
                      <span class="leyenda-agencias__color" :style="{ backgroundColor: colores[index % colores.length] }"></span>
                      <span><strong>{{ camino.camino_nombre }}</strong><br><small>{{ camino.total_reservas }} reservas ({{ porcentajeCamino(agencia, camino.total_reservas) }}%)</small></span>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else justify="center" class="py-6"><span>No hay datos de caminos disponibles</span></v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import * as XLSX from 'xlsx';

export default {
  data: () => ({
    busquedaDesde: '',
    busquedaHasta: '',
    errorDesde: '',
    errorHasta: '',
    colores: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40', '#C9CBCF'],
    headers: [
      { text: 'AGENCIA', align: 'left', sortable: false, value: 'origen_nombre' },
      //{ text: 'DESDE WEB PRESUPUESTADAS', align: 'center', sortable: false, value: 'DesdeWebPresupuestadas', width: '130px' },
      //{ text: 'DESDE WEB CONFIRMADAS', align: 'center', sortable: false, value: 'DesdeWebReservadas', width: '130px' },
      { text: 'PRESUPUESTADAS', align: 'center', sortable: false, value: 'DesdeOficinaPresupuestadas', width: '130px' },
      { text: 'RESERVAS', align: 'center', sortable: false, value: 'DesdeOficinaReservadas', width: '130px' },
      { text: 'TOTAL', align: 'center', sortable: false, value: 'total_reservas', width: '100px' },
    ],
  }),

  computed: {
    ...mapState(['loading', 'dark', 'colorAccent1', 'colorBarraFormulario']),
    ...mapState('auth', ['access_token']),
    ...mapState('reportes', ['reporteMarketingAgencia', 'reporteMarketingAgenciaPorCamino']),

    porOrigen() {
      return Array.isArray(this.reporteMarketingAgencia?.por_origen) ? this.reporteMarketingAgencia.por_origen : [];
    },

    porOrigenConCaminos() {
      return Array.isArray(this.reporteMarketingAgenciaPorCamino?.por_origen)
        ? this.reporteMarketingAgenciaPorCamino.por_origen
        : [];
    },

    datosGrafica() {
      return this.porOrigen.filter(item => Number(item.total_reservas) > 0);
    },

    totalGrafica() {
      return this.datosGrafica.reduce((total, item) => total + (Number(item.total_reservas) || 0), 0);
    },

    totales() {
      return this.porOrigen.reduce((acc, item) => {
        acc.DesdeWebPresupuestadas += Number(item.DesdeWebPresupuestadas) || 0;
        acc.DesdeWebReservadas += Number(item.DesdeWebReservadas) || 0;
        acc.DesdeOficinaPresupuestadas += Number(item.DesdeOficinaPresupuestadas) || 0;
        acc.DesdeOficinaReservadas += Number(item.DesdeOficinaReservadas) || 0;
        acc.total += Number(item.total_reservas) || 0;
        return acc;
      }, { DesdeWebPresupuestadas: 0, DesdeWebReservadas: 0, DesdeOficinaPresupuestadas: 0, DesdeOficinaReservadas: 0, total: 0 });
    },
  },

  watch: {
    porOrigen: {
      handler() {
        this.$nextTick(() => {
          this.dibujarGraficaPastel();
          this.dibujarGraficasCaminos();
        });
      },
      deep: true,
    },
    porOrigenConCaminos: {
      handler() { this.$nextTick(this.dibujarGraficasCaminos); },
      deep: true,
    },
  },

  mounted() {
    this._getReporteMarketingAgencia();
  },

  methods: {
    ...mapActions('reportes', ['getReporteMarketingAgencia', 'getReporteMarketingAgenciaPorCamino']),

    porcentaje(valor) {
      return this.totalGrafica ? ((Number(valor) || 0) * 100 / this.totalGrafica).toFixed(1) : '0.0';
    },

    caminosConReserva(agencia) {
      return Array.isArray(agencia?.caminos)
        ? agencia.caminos.filter(camino => Number(camino.total_reservas) > 0)
        : [];
    },

    totalCaminos(agencia) {
      return this.caminosConReserva(agencia).reduce((total, camino) => total + (Number(camino.total_reservas) || 0), 0);
    },

    porcentajeCamino(agencia, valor) {
      const total = this.totalCaminos(agencia);
      return total ? ((Number(valor) || 0) * 100 / total).toFixed(1) : '0.0';
    },

    dibujarGraficaPastel() {
      const canvas = this.$refs.pieChart;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const centerX = canvas.width / 2;
      const centerY = canvas.height / 2;
      const radius = Math.min(centerX, centerY) - 40;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      if (!this.datosGrafica.length) {
        ctx.font = '16px Arial';
        ctx.fillStyle = '#666';
        ctx.textAlign = 'center';
        ctx.fillText('No hay datos para mostrar', centerX, centerY);
        return;
      }

      let startAngle = -Math.PI / 2;
      this.datosGrafica.forEach((item, index) => {
        const value = Number(item.total_reservas) || 0;
        const sliceAngle = (value / this.totalGrafica) * 2 * Math.PI;
        const endAngle = startAngle + sliceAngle;
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fillStyle = this.colores[index % this.colores.length];
        ctx.fill();
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 2;
        ctx.stroke();

        if (this.porcentaje(value) > 5) {
          const midAngle = startAngle + sliceAngle / 2;
          ctx.fillStyle = '#fff';
          ctx.font = 'bold 16px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(`${this.porcentaje(value)}%`, centerX + radius * 0.7 * Math.cos(midAngle), centerY + radius * 0.7 * Math.sin(midAngle));
        }
        startAngle = endAngle;
      });
    },

    dibujarGraficasCaminos() {
      this.porOrigenConCaminos.forEach((agencia) => {
        const canvasRef = this.$refs[`pieChartCamino${agencia.origen_id}`];
        const canvas = Array.isArray(canvasRef) ? canvasRef[0] : canvasRef;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        const centerX = canvas.width / 2;
        const centerY = canvas.height / 2;
        const radius = Math.min(centerX, centerY) - 35;
        const caminos = this.caminosConReserva(agencia);
        const total = this.totalCaminos(agencia);
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (!caminos.length) {
          ctx.font = '16px Arial';
          ctx.fillStyle = '#666';
          ctx.textAlign = 'center';
          ctx.fillText('No hay datos para mostrar', centerX, centerY);
          return;
        }

        let startAngle = -Math.PI / 2;
        caminos.forEach((camino, index) => {
          const value = Number(camino.total_reservas) || 0;
          const sliceAngle = (value / total) * 2 * Math.PI;
          const endAngle = startAngle + sliceAngle;
          ctx.beginPath();
          ctx.moveTo(centerX, centerY);
          ctx.arc(centerX, centerY, radius, startAngle, endAngle);
          ctx.closePath();
          ctx.fillStyle = this.colores[index % this.colores.length];
          ctx.fill();
          ctx.strokeStyle = '#fff';
          ctx.lineWidth = 2;
          ctx.stroke();

          if (this.porcentajeCamino(agencia, value) > 5) {
            const midAngle = startAngle + sliceAngle / 2;
            ctx.fillStyle = '#fff';
            ctx.font = 'bold 14px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(`${this.porcentajeCamino(agencia, value)}%`, centerX + radius * 0.68 * Math.cos(midAngle), centerY + radius * 0.68 * Math.sin(midAngle));
          }
          startAngle = endAngle;
        });
      });
    },

    _exportarExcel() {
      const datos = this.porOrigen.map(item => ({
        AGENCIA: item.origen_nombre || '',
        'DESDE WEB PRESUPUESTADAS': item.DesdeWebPresupuestadas || 0,
        'DESDE WEB CONFIRMADAS': item.DesdeWebReservadas || 0,
        'DESDE OFICINA PRESUPUESTADAS': item.DesdeOficinaPresupuestadas || 0,
        'DESDE OFICINA CONFIRMADAS': item.DesdeOficinaReservadas || 0,
        TOTAL: item.total_reservas || 0,
      }));
      datos.push({ AGENCIA: 'TOTALES', 'DESDE WEB PRESUPUESTADAS': this.totales.DesdeWebPresupuestadas, 'DESDE WEB CONFIRMADAS': this.totales.DesdeWebReservadas, 'DESDE OFICINA PRESUPUESTADAS': this.totales.DesdeOficinaPresupuestadas, 'DESDE OFICINA CONFIRMADAS': this.totales.DesdeOficinaReservadas, TOTAL: this.totales.total });
      const libro = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(libro, XLSX.utils.json_to_sheet(datos), 'Por Agencia');
      XLSX.writeFile(libro, `Reporte_Marketing_Agencia_${new Date().toISOString().split('T')[0]}.xlsx`);
    },

    validateFechaDesde() { this.errorDesde = this.busquedaDesde && !this.isValidDateFormat(this.busquedaDesde) ? 'El formato debe ser AAAA-MM-DD (ej: 2026-01-01)' : ''; },
    validateFechaHasta() { this.errorHasta = this.busquedaHasta && !this.isValidDateFormat(this.busquedaHasta) ? 'El formato debe ser AAAA-MM-DD (ej: 2026-12-31)' : ''; },

    isValidDateFormat(valor) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(valor)) return false;
      const [year, month, day] = valor.split('-').map(Number);
      const fecha = new Date(valor);
      return fecha.getFullYear() === year && fecha.getMonth() === month - 1 && fecha.getDate() === day;
    },

    async _getReporteMarketingAgencia() {
      this.validateFechaDesde();
      this.validateFechaHasta();
      if (this.errorDesde || this.errorHasta) return;
      const params = {};
      if (this.busquedaDesde) params.fecha_desde = this.busquedaDesde;
      if (this.busquedaHasta) params.fecha_hasta = this.busquedaHasta;
      await Promise.all([
        this.getReporteMarketingAgencia([this.access_token, params]),
        this.getReporteMarketingAgenciaPorCamino([this.access_token, params]),
      ]);
    },
  },
};
</script>

<style scoped>
.alternating-rows>>>tbody tr:nth-child(even) { background-color: #ebebeb !important; }
.bordered-table { border: 1px solid rgba(0, 0, 0, 0.12); }
.bordered-table ::v-deep th, .bordered-table ::v-deep td { border-right: 1px solid rgba(0, 0, 0, 0.12) !important; }
.bordered-table ::v-deep th:last-child, .bordered-table ::v-deep td:last-child { border-right: none !important; }
.bordered-table ::v-deep tr { border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important; }
.leyenda-agencias { width: 100%; max-height: 400px; overflow-y: auto; }
.leyenda-agencias__item { display: flex; align-items: center; gap: 12px; padding: 8px; margin-bottom: 8px; background: #f5f5f5; border-radius: 4px; }
.leyenda-agencias__color { width: 24px; height: 24px; border: 2px solid #333; border-radius: 3px; flex-shrink: 0; }
</style>
